var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Lifecycle, scoped } from 'tsyringe';
import { NAMESPACES, PersistenceManager } from '../PersistenceManager';
import { StreamrClientEventEmitter } from '../events';
import { LoggerFactory } from '../utils/LoggerFactory';
import { GroupKey } from './GroupKey';
function formLookupKey1(keyId, publisherId) {
    return `${publisherId}::${keyId}`;
}
function formLookupKey2(publisherId, streamId) {
    return `${publisherId}::${streamId}`;
}
let LocalGroupKeyStore = class LocalGroupKeyStore {
    persistenceManager;
    eventEmitter;
    logger;
    constructor(persistenceManager, eventEmitter, loggerFactory) {
        this.persistenceManager = persistenceManager;
        this.eventEmitter = eventEmitter;
        this.logger = loggerFactory.createLogger('LocalGroupKeyStore');
    }
    async get(keyId, publisherId) {
        const persistence = await this.persistenceManager.getPersistence(NAMESPACES.ENCRYPTION_KEYS);
        const value = await persistence.get(formLookupKey1(keyId, publisherId));
        if (value !== undefined) {
            return new GroupKey(keyId, Buffer.from(value, 'hex'));
        }
        else {
            return undefined;
        }
    }
    async set(keyId, publisherId, data) {
        const persistence = await this.persistenceManager.getPersistence(NAMESPACES.ENCRYPTION_KEYS);
        await persistence.set(formLookupKey1(keyId, publisherId), Buffer.from(data).toString('hex'));
        this.logger.debug('Set key', { keyId, publisherId });
        this.eventEmitter.emit('encryptionKeyStoredToLocalStore', keyId);
    }
    async setLatestEncryptionKeyId(keyId, publisherId, streamId) {
        const persistence = await this.persistenceManager.getPersistence(NAMESPACES.LATEST_ENCRYPTION_KEY_IDS);
        this.logger.debug('Set latest encryptionKeyId', { keyId, publisherId, streamId });
        await persistence.set(formLookupKey2(publisherId, streamId), keyId);
    }
    async getLatestEncryptionKeyId(publisherId, streamId) {
        const persistence = await this.persistenceManager.getPersistence(NAMESPACES.LATEST_ENCRYPTION_KEY_IDS);
        const value = await persistence.get(formLookupKey2(publisherId, streamId));
        return value;
    }
};
LocalGroupKeyStore = __decorate([
    scoped(Lifecycle.ContainerScoped),
    __metadata("design:paramtypes", [PersistenceManager,
        StreamrClientEventEmitter,
        LoggerFactory])
], LocalGroupKeyStore);
export { LocalGroupKeyStore };
//# sourceMappingURL=LocalGroupKeyStore.js.map